import {
  localStorageKey,
  maxIdleTimeout,
  maxTokenAliveTime,
  recordPeriod,
  tableSetting,
  userType,
  userPrivilege,
  userPermissions,
} from "./user";
import { organizationType } from "./organization";
import {
  deviceType,
  deviceConfig,
  deviceStates,
  statusList,
  searchItemUseSelect,
} from "./device";
import { timeFormat } from "./dateFormat";
import { regex } from "./regex";
import { licenseConfig } from "./license";
import { pageLimits, defaultPageLimit } from "./component";
import { reloadState } from "./system";

export default {
  localStorageKey,
  maxIdleTimeout,
  maxTokenAliveTime,
  recordPeriod,
  tableSetting,
  userType,
  userPrivilege,
  userPermissions,
  organizationType,
  deviceType,
  deviceConfig,
  deviceStates,
  statusList,
  searchItemUseSelect,
  timeFormat,
  regex,
  licenseConfig,
  pageLimits,
  defaultPageLimit,
  reloadState,
};
